import React, { Component } from 'react';
import { Col, Row, Container, Image } from 'react-bootstrap';

import './Services.css';

import about1 from './../../_assets/images/about1.jpg';
import about2 from './../../_assets/images/about2.jpg';

class Services extends Component {
    render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h2 className="h4 mt-4 text-black text-uppercase">Services</h2>
                        <hr />
                    </Col>
                </Row>
                <Row className="tabPanelrow">
                    <Col md={6}>
                        <div className="tabpanels">
                            <h3>About our technologies</h3>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> commercial renewable and energy saving for business.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> the power of solar energy at your home.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> Geothermal electric infrastructure systems.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> wind and solar hydrogen & fuel cells.</p>
                        </div>
                    </Col>
                    <Col md={6}>
                        <Image className="img" src={about1} alt="about1" />
                    </Col>
                </Row>
                <Row className="tabPanelrow">
                    <Col md={6} >
                        <Image className="img" src={about2} alt="about2" />
                    </Col>
                    <Col md={6}>
                        <div className="tabpanels">
                            <h3>Managing solar energy saving</h3>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> biomass Solar power and basic sciences.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> eco psychology and manufacturing solar panels.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> Research in saving power of science & technology.</p>
                            <p><i className="fa fa-lightbulb-o" aria-hidden="true"></i> Connections made easy to increase solar energy.</p>
                        </div>
                    </Col>
                </Row>

                <Row><br /></Row>
            </Container>
        )
    }
}

export default Services;